import React from 'react';
import { useRBAC } from '../contexts/RBACContext';
import { Box, Typography, Container, Button } from '@mui/material';
import { PiLock } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';

interface EditorRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for editor-level access.
 * Allows access to users with 'editor', 'admin', or 'super-admin' roles.
 * Used for Workflow Studio and other workflow editing features.
 */
export default function EditorRoute({ children }: EditorRouteProps) {
  const { canAccessWorkflowStudio, loading } = useRBAC();
  const navigate = useNavigate();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Typography>Loading permissions...</Typography>
      </Box>
    );
  }

  if (!canAccessWorkflowStudio()) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}><PiLock size={80} style={{ opacity: 0.54 }} /></Box>
        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You need editor or administrator privileges to access Workflow Studio.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/')}>
          Return to Dashboard
        </Button>
      </Container>
    );
  }

  return <>{children}</>;
}
